// eslint-disable-next-line import/no-anonymous-default-export
export default {
  formId: "new-user-form",
  formField: {
    // datas
    name: {
      name: "name",
      label: "Nome Completo",
      type: "text",
      errorMsg: "O nome completo é obrigatório",
      invalidMsg: "Nome completo inválido",
    },
    email: {
      name: "email",
      label: "Email",
      type: "email",
      errorMsg: "O email é obrigatório",
      invalidMsg: "Email inválido",
    },
    company: {
      name: "company",
      label: "Companhia",
      type: "text",
      errorMsg: "O companhia é obrigatório",
      invalidMsg: "Companhia inválido",
    },
  },
};